import { css, SerializedStyles } from '@emotion/core';
import styled from '@emotion/styled';
import { Card } from '@material-ui/core';

import { ICustomTheme } from 'interfaces';

export const setVariant = (
  variant: string,
  theme: ICustomTheme,
): SerializedStyles => {
  switch (variant) {
    case 'error':
      return css`
        background-color: crimson;
        color: ${theme.colors.white};
      `;
    case 'success':
      return css`
        background-color: greenyellow;
        color: ${theme.colors.white};
      `;
    case 'warning':
      return css`
        background-color: orange;
        color: ${theme.palette.grey.A400};
      `;
    case 'info':
      return css`
        background-color: lightblue;
        color: ${theme.palette.grey.A400};
      `;
    default:
      return css`
        background-color: ${theme.palette.grey.A400};
        color: ${theme.colors.white};
      `;
  }
};

export const StyledCard = styled(Card)<{ theme: ICustomTheme }>`
  display: flex;
  flex: 1 0 auto;
  min-height: 6rem;
  width: 33rem;
`;

export const Banner = styled.div<{ variant: string; theme: ICustomTheme }>`
  width: 1rem;
  height: 100%;
  ${({ variant, theme }) => setVariant(variant, theme)};
`;
